import { IdNameDto } from "../../Types/common";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface FieldConfig<_T = any> {
	name: string;
	label: string;
	type: SearchFormTypes;
	options?: IdNameDto[];
	value?: any;
	rows?: number;
}

export interface GenericSearchFormProps<TFilters> {
	onSearch: (filters: TFilters) => void;
}

export enum SearchFormTypes {
	input = "input",
	textarea = "textarea",
	select = "select",
	radio = "radio",
	checkbox = "checkbox",
	number = "number",
	email = "email",
	date = "date",
	switch = "switch",
	file = "file",
	autocomplete = "autocomplete",
	wysiwyg = "wysiwyg",
	dynamicList = "dynamicList",
	offerOptions = "offerOptions",
}